import React from 'react'
import { Line } from 'rc-progress'

const MacroData = (props) => {
  const trackerData = props.trackerData

  const getFiber = (carb) => {
    if(carb <= 75) return 10;
    else if(carb > 75 && carb <= 125) return 15;
    else if(carb > 125 && carb <= 175) return 20;
    else if(carb > 175 && carb <= 250) return 25;
    else if(carb > 250) return 30;
  }

  const renderLineGraphs = () => {
    let consumedAvgCalories = props.avgCalories
    let avgCaloriesTarget = props.avgCaloriesTarget
    let consumedAvgFiber = props.avgFiber
    let avgFiberTarget = getFiber(avgCaloriesTarget)

    let remainingAvgCalories = Math.round(avgCaloriesTarget - consumedAvgCalories);
    let remainingAvgFiber = Math.round(avgFiberTarget - consumedAvgFiber);
    
    let percentCalories = ((consumedAvgCalories / avgCaloriesTarget) * 100);
    let percentFiber = ((consumedAvgFiber / avgFiberTarget) * 100);

    let displayTextCalories
    let displayTextFiber

    if (trackerData.showConsumedMacros || props.vacationMode === 2) {
      // Average Consumed
      displayTextCalories = `${Math.round(consumedAvgCalories)} Eaten`
      displayTextFiber = `${Math.round(consumedAvgFiber)} Eaten`
    } else {
      // Average Remaining
      displayTextCalories = `${Math.round(remainingAvgCalories)} Left`
      displayTextFiber = `${Math.round(remainingAvgFiber)} Left`
    }

    return (
      <div className="tracker-data-container">
        <div className="tracker-data-macros-container">
          <div className="tracker-data-text">
            <label>AVG. CALORIES</label>
            <Line
              percent={percentCalories}
              strokeWidth="9"
              strokeLinecap="round"
              strokeColor="#31bfff"
              trailWidth="9"
              trailColor="#1d2345"
            />
            <label style={{color: '#FFF'}}>{displayTextCalories}</label>
          </div>
          <div className="tracker-data-text">
            <label>AVG. FIBER</label>
            <Line
              percent={percentFiber}
              strokeWidth="9"
              strokeLinecap="round"
              strokeColor="#31bfff"
              trailWidth="9"
              trailColor="#1d2345"
            />
            <label style={{color: '#FFF'}}>{displayTextFiber}</label>
          </div>
        </div>
      </div>
    );
  }

  return <div>{renderLineGraphs()}</div>
}

export default MacroData

